module.exports = __webpack_public_path__ + "static/media/arrow_white.7c425956.svg";